import { defineStore } from 'pinia';

export type NotificationType = "information" | "success" | "error" | "warning";
export interface NotificationParams {
    title: string;
    message: string;
    type: NotificationType;
}
export interface Notification extends NotificationParams {
    id: string;
    ttl: number;
}

export const useNotificationStore = defineStore('notifications', {
  state: () => {
    return {
        notifications: [] as Notification[],
    };
  },
  getters: {
    activeNotifications(): Notification[] {
        return this.notifications;
    }
  },
  actions: {
    add(params: NotificationParams, ttl = 5000) {
        const notif: Notification = {
            id: crypto.randomUUID(),
            ...params,
            ttl
        }
        this.notifications.push(notif);
        if (ttl >= 0) {
            setTimeout(() => {
                this.remove(notif.id);
            }, ttl);
        }
    },
    information(title:string, message: string, ttl = 5000) {
      this.add({title, message, type: "information"}, ttl);
    },
    success(title:string, message: string, ttl = 5000) {
      this.add({title, message, type: "success"}, ttl);
    },
    error(title:string, message: string, ttl = 5000) {
      this.add({title, message, type: "error"}, ttl);
    },
    warning(title:string, message: string, ttl = 5000) {
      this.add({title, message, type: "warning"}, ttl);
    },
    remove(notificationId: string) {
        this.notifications = this.notifications.filter(n => n.id !== notificationId);
    }
  },
});